export const PERIODS = {
  defaultFormValue: 'P5Y',
  minPeriod: 'P1D',
  maxPeriod: 'P30Y',
};

export const MIN_PERIOD_DURATION = 1;
